import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { WalletOverview } from '@/types/wallet'

/** `GET /app/wallet/me` → `{ balance, txs[] }`。 */
export function getWalletMe(): Promise<ApiResponse<WalletOverview>> {
  return http.get<ApiResponse<WalletOverview>>('/app/wallet/me').then((r) => r.data)
}
